import { render, staticRenderFns } from "./zlvScheme.vue?vue&type=template&id=538b0e67&scoped=true&"
import script from "./zlvScheme.vue?vue&type=script&lang=js&"
export * from "./zlvScheme.vue?vue&type=script&lang=js&"
import style0 from "./zlvScheme.vue?vue&type=style&index=0&id=538b0e67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b0e67",
  null
  
)

export default component.exports